<template>
  <div class="processing-container safe-top">
    <div class="processing-title">処理中です</div>
    <div>
      <PulseLoader class="processing-loader" color="#fdc908" />
      <span>このままお待ちください。</span>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import API from "@/API";

export default {
  name: "TemplateMfittBookingProcessing",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const bookingResult = computed(() => {
      return store.getters["MFITT/bookingResult"];
    });

    const inputtedInfoOnBooking = store.getters["MFITT/inputtedInfoOnBooking"];

    const goToBookingResultPage = () => {
      router.push({
        name: "MfittBookingResult",
        params: { id: route.params.id },
        query: {
          method: "booking",
          coupon_id: route.query.coupon_id,
          ticket_id: route.query.payment_limited_express_ticket_id,
        }, // 予約/購入:booking, 変更:change
      });
    };

    const goToBookingErrorPage = () => {
      let method;
      if (inputtedInfoOnBooking?.method == "シート指定") {
        method = "seat";
      } else if (inputtedInfoOnBooking?.method == "条件指定") {
        method = "conditions";
      }
      router.push({
        name: "MfittBookingError",
        params: { id: route.params.id },
        query: {
          coupon_id: route.query.coupon_id,
          payment_limited_express_ticket_id:
            route.query.payment_limited_express_ticket_id,
        },
      });
    };

    const goToVacantSeatsErrorPage = () => {
      let method;
      if (inputtedInfoOnBooking?.method == "シート指定") {
        method = "seat";
      } else if (inputtedInfoOnBooking?.method == "条件指定") {
        method = "conditions";
      }

      router.push({
        name: "MfittBookingVacantSeatsError",
        params: { id: route.params.id },
        query: {
          specifyMethod: method,
        },
      });
    };

    const goToBookingSalesEndErrorPage = () => {
      router.push({
        name: "MfittBookingSalesEndError",
        params: { id: route.params.id },
      });
    };

    const goToBookingMailSentErrorPage = () => {
      let method;
      if (inputtedInfoOnBooking.method == "シート指定") {
        method = "seat";
      } else if (inputtedInfoOnBooking.method == "条件指定") {
        method = "conditions";
      }

      router.push({
        name: "MfittBookingMailSentError",
        params: { id: route.params.id },
        query: { specifyMethod: method, coupon_id: route.query.coupon_id },
      });
    };

    const gotoBookingTimeoutPage = () => {
      router.push({
        name: "MfittBookingTimeoutPage",
        params: { id: route.params.id },
        query: { coupon_id: route.query.coupon_id },
      });
    };

    const handleBookingResult = async () => {
      if (bookingResult.value?.result === "success") {
        if (!bookingResult.value?.mail_sent) {
          goToBookingMailSentErrorPage();
        } else {
          await API.getMyLimitedExpressTicket(
            bookingResult.value.limited_express_ticket_id
          );
          goToBookingResultPage();
        }
      } else if (bookingResult.value?.result === "error") {
        if (bookingResult.value?.error === "departed") {
          goToBookingSalesEndErrorPage();
        } else if (bookingResult.value?.error === "no_vacant_seats") {
          goToVacantSeatsErrorPage();
        } else {
          goToBookingErrorPage();
        }
      } else if (bookingResult.value?.result === "timeout") {
        gotoBookingTimeoutPage();
      }
      store.commit("MFITT/setBookingResult", null);
    };

    onMounted(() => {
      if (bookingResult.value) {
        handleBookingResult();
      }
    });

    watch(bookingResult, (newValue) => {
      handleBookingResult();
    });

    return {
      goToBookingResultPage,
      goToBookingErrorPage,
    };
  },
};
</script>
<style lang="scss" scoped>
.safe-top {
  margin-top: calc(30px + env(safe-area-inset-top, 30px) + 30px);
}

.processing-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .processing-loader {
    text-align: center;
    margin-top: 0;
    margin-bottom: 15px;
  }

  .processing-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
    position: absolute;
    top: 30px;
  }
}
</style>
